import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { VisitAttributes } from '@albatrosdeveloper/ave-models-package';

/**
 * Reason Cell Renderer
 *
 * Renders the visit reason name from the reasonForVisit object
 *
 * @example
 * ```typescript
 * {
 *   field: 'reasonForVisit',
 *   headerName: 'Motivo de Visita',
 *   cellRenderer: ReasonCellRendererComponent
 * }
 * ```
 */
@Component({
  selector: 'app-reason-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `<span class="text-sm">{{ reasonName }}</span>`,
  styles: []
})
export class ReasonCellRendererComponent implements CellRenderer<VisitAttributes> {
  @Input() params!: CellRendererParams<VisitAttributes>;

  get reasonName(): string {
    return this.params.data?.reasonForVisit?.name || '-';
  }
}
